import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { get, post } from "../../../utils/HttpRequest";
import config from "../../../config/config.json";
import { Toast } from "primereact/toast";
import { Button, Form, Col, Row } from "react-bootstrap";

const AssessmentMaxAttemptsForm = () => {
  const toast = useRef(null);
  const formRef = useRef();
  const [validated, setValidated] = useState(false);
  const [maxAttempts, setMaxAttempts] = useState("");
  const [group, setGroup] = useState("");

  const getMaxAttempts = async () => {
    try {
      const url = config.api.url + "getTrialConfig/noOfMaxAttemptsAllowedForAssessment";
      get(url).then((response) => {
        if(response && response.data){
            let valueData = response.data;
            setMaxAttempts(valueData.value);
            setGroup(valueData.group);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getMaxAttempts();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      event.stopPropagation();
      return;
    }
    try {
      const formData = {
        name: 'noOfMaxAttemptsAllowedForAssessment',
        value: parseInt(form.maxAttempts.value),
      };
      var url = config.api.url + "updateTrialConfig";
      post(url, formData)
        .then((response) => {
          if (response.status === 201 || response.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Maximum assessment attempts has been updated",
              detail: "Success",
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "something went wrong",
              detail: "something went wrong",
            });
          }
        })
        .catch(function (error) {
          if (error.response.status === 400 || error.response.status === 401) {
            toast.current.show({
              severity: "error",
              summary: "something went wrong",
              detail: "something went wrong",
            });
          }
        });
      setValidated(false);
    } catch (error) {
      console.error("Error while making API call:", error);
    }
  };

  return (
    <div className="app">
      <Toast ref={toast}></Toast>
      <hr />
      <Row>
        <Col lg={12}>
          <span className="card-title">Set Maximum Assessment Limit</span>
          <p className="px-2">
            Set the maximum number of attempts allowed for assessments
          </p>
          <Form
            id="settingsPageMaxAttempts"
            className="needs-validation"
            onSubmit={handleSubmit}
            noValidate
            ref={formRef}
            validated={validated}
          >
            <div className="col-sm-12 col-md-2 mb-3 mt-3">
              <Form.Group>
                <Form.Control
                  type="number"
                  className="form-control input-group"
                  name="maxAttempts"
                  min="1"
                  required
                  value={maxAttempts}
                  onChange={(e) => setMaxAttempts(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="form-actions ml-2 mb-4">
              <Button className="btn btn-primary px-3" type="submit">
                Save
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default AssessmentMaxAttemptsForm;